import { render, staticRenderFns } from "./userworks.vue?vue&type=template&id=40e25b29&scoped=true&"
import script from "./userworks.vue?vue&type=script&lang=js&"
export * from "./userworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e25b29",
  null
  
)

export default component.exports